<template>
  <div class="not-found">
    <div class="w3-display-middle" style="text-align:center;">
      <h1 style="font-size:200px; margin:0; padding:0; line-height:1em;">404</h1>
      <span>(not found)</span>
      <p style="font-size:24px; margin:15px 0 0; padding:0; line-height:1em;">That's an error, please start from <router-link to="/">Home</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "not-found",
  data: function() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.not-found {
  margin-top: 40px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue